// src/features/procedures/components/steps/NumberInputStep.jsx
import React from 'react';
import { InputAdornment, TextField } from '@mui/material';

/**
 * Number Input Step Component
 *
 * Validation Rules Config (all optional):
 * {
 *   "min": 0,
 *   "max": 1000,
 *   "unit": "CFU/ml"   // Shown after the field
 * }
 */
export default function NumberInputStep({ step, value, onChange, disabled, preview }) {
  const rules = step.validation_rules || {};

  return (
    <TextField
      type="number"
      size="small"
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled || preview}
      sx={{ width: 220 }}
      inputProps={{ min: rules.min, max: rules.max, inputMode: 'decimal' }}
      InputProps={rules.unit ? {
        endAdornment: <InputAdornment position="end">{rules.unit}</InputAdornment>,
      } : undefined}
    />
  );
}
